export type TicketType = "bug" | "feature" | "fix";

export type TicketState =
  | "new"
  | "ready_for_implementation"
  | "in_progress"
  | "ready_for_acceptance"
  | "done";

export const TICKET_TYPES: TicketType[] = ["bug", "feature", "fix"];

export const TICKET_STATES: TicketState[] = [
  "new",
  "ready_for_implementation",
  "in_progress",
  "ready_for_acceptance",
  "done",
];

export const STATE_LABELS: Record<TicketState, string> = {
  new: "New",
  ready_for_implementation: "Ready for Impl.",
  in_progress: "In Progress",
  ready_for_acceptance: "Ready for Accept.",
  done: "Done",
};

export const TYPE_LABELS: Record<TicketType, string> = {
  bug: "Bug",
  feature: "Feature",
  fix: "Fix",
};

export interface User {
  id: string;
  email: string;
  verified: boolean;
}

export interface AuthResponse {
  accessToken: string;
  user: User;
}

export interface MessageResponse {
  message: string;
}

export interface Team {
  id: string;
  name: string;
  createdAt: string;
  modifiedAt: string;
}

export interface Epic {
  id: string;
  teamId: string;
  title: string;
  createdAt: string;
  modifiedAt: string;
}

export interface Ticket {
  id: string;
  teamId: string;
  type: TicketType;
  state: TicketState;
  epicId: string | null;
  title: string;
  body: string;
  createdAt: string;
  modifiedAt: string;
  createdBy: string;
  createdByEmail: string;
}

export interface Comment {
  id: string;
  ticketId: string;
  body: string;
  createdAt: string;
  createdBy: string;
  createdByEmail: string;
}

export interface BoardCard {
  id: string;
  type: TicketType;
  state: TicketState;
  epicId: string | null;
  title: string;
  modifiedAt: string;
  createdBy: string;
}

export interface BoardColumn {
  state: TicketState;
  tickets: BoardCard[];
}

export interface Board {
  teamId: string;
  columns: BoardColumn[];
}
